export enum EModals {
  SINGLE_CARD_VIEW = "single-card-view",
}
